(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-brand"] && !Shopify.designMode) return;
  try {
    
  function initBrandFinder(root) {
    if (!root || root.dataset.brandFinderEnhanced === 'true') return;

    function normalizeBrandText(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/&amp;/g, '&')
        .toLowerCase()
        .trim();
    }

    var input = root.querySelector('[data-brand-search-input]');
    var status = root.querySelector('[data-brand-status]');
    var noResults = root.querySelector('[data-brand-no-results]');
    var reset = root.querySelector('[data-brand-reset]');
    var results = root.querySelector('[data-brand-results]');
    var loader = root.querySelector('[data-brand-loader]');
    var nextLink = root.querySelector('[data-brand-next-link]');
    var loaderStatus = root.querySelector('[data-brand-loader-status]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-brand-filter]'));
    var blocks = [];

    if (!results || !status) return;

    var totalBrands = Number(root.dataset.totalBrands || 0);
    var currentPage = Number(results.dataset.currentPage || 1);
    var lastPage = Number(results.dataset.lastPage || currentPage);
    var nextSequentialPage = currentPage > 1 ? 1 : currentPage + 1;
    var loadedPages = {};
    var pagePromises = {};
    var activeHandle = 'all';
    var debounceTimer = null;
    var interactionId = 0;
    var autoObserver = null;
    var nextLinkIdleText = nextLink ? nextLink.textContent : 'Mehr Marken laden';
    var pendingPageLoads = 0;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    loadedPages[currentPage] = true;

    root.classList.add('is-enhanced');
    root.dataset.brandFinderEnhanced = 'true';

    function collectBlocks() {
      blocks = Array.prototype.slice.call(root.querySelectorAll('[data-brand-block]')).map(function (element) {
        return {
          element: element,
          handle: element.dataset.brandHandle || '',
          title: element.dataset.brandTitle || '',
          search: normalizeBrandText(element.dataset.brandSearch || ''),
          count: Number(element.dataset.productCount || 0)
        };
      });

      if (!totalBrands) totalBrands = blocks.length;
      return blocks;
    }

    function getSectionId() {
      var sectionElement = root.closest('.shopify-section');
      if (!sectionElement || !sectionElement.id) return '';
      return sectionElement.id.replace(/^shopify-section-/, '');
    }

    function buildBrandPageUrl(page, hash) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.searchParams.delete('section_id');
      url.hash = hash || '';
      return url;
    }

    function getSectionFetchUrl(page) {
      var url = buildBrandPageUrl(page);
      var sectionId = getSectionId();
      if (sectionId) url.searchParams.set('section_id', sectionId);
      url.hash = '';
      return url;
    }

    function getBrandIndex() {
      return chips
        .filter(function (chip) {
          return chip.dataset.brandFilter && chip.dataset.brandFilter !== 'all';
        })
        .map(function (chip) {
          return {
            handle: chip.dataset.brandFilter,
            page: Number(chip.dataset.brandPage || 1),
            search: normalizeBrandText(chip.dataset.brandSearch || chip.textContent)
          };
        });
    }

    function getBlockByHandle(handle) {
      collectBlocks();
      return blocks.find(function (block) {
        return block.handle === handle;
      });
    }

    function sortBlocksByBrandIndex() {
      Array.prototype.slice.call(results.querySelectorAll('[data-brand-block]'))
        .sort(function (a, b) {
          var indexA = Number(a.dataset.brandIndex || 9999);
          var indexB = Number(b.dataset.brandIndex || 9999);
          return indexA - indexB;
        })
        .forEach(function (block) {
          results.appendChild(block);
        });
      collectBlocks();
    }

    function syncNextLink() {
      if (!nextLink) return;

      while (nextSequentialPage <= lastPage && loadedPages[nextSequentialPage]) {
        nextSequentialPage += 1;
      }

      if (nextSequentialPage <= lastPage) {
        nextLink.href = buildBrandPageUrl(nextSequentialPage).toString();
        nextLink.hidden = false;
        if (loader) loader.hidden = false;
        return;
      }

      nextLink = null;
      if (loader) {
        loader.classList.remove('is-loading');
        loader.hidden = true;
      }
      if (autoObserver) autoObserver.disconnect();
    }

    function appendBlocksFromHTML(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fetchedRoot = parsed.querySelector('[data-brand-finder-root]') || parsed;
      var incomingBlocks = Array.prototype.slice.call(fetchedRoot.querySelectorAll('[data-brand-results] [data-brand-block]'));
      var existingHandles = {};
      var appendedCount = 0;
      var firstAppendedBlock = null;

      collectBlocks().forEach(function (block) {
        existingHandles[block.handle] = true;
      });

      incomingBlocks.forEach(function (blockElement) {
        var handle = blockElement.dataset.brandHandle || '';
        if (!handle || existingHandles[handle]) return;

        existingHandles[handle] = true;
        if (!firstAppendedBlock) firstAppendedBlock = blockElement;
        results.appendChild(blockElement);
        appendedCount += 1;
      });

      sortBlocksByBrandIndex();
      return {
        appendedCount: appendedCount,
        firstAppendedBlock: firstAppendedBlock
      };
    }

    function setLoaderState(isLoading, message) {
      if (loader) loader.classList.toggle('is-loading', isLoading);
      results.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (nextLink) {
        nextLink.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        nextLink.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        nextLink.textContent = isLoading ? 'Lädt ...' : nextLinkIdleText;
      }
      if (loaderStatus) {
        loaderStatus.hidden = !message;
        loaderStatus.textContent = message || '';
      }
    }

    async function loadPage(page) {
      page = Number(page || 0);
      if (!page || page < 1 || page > lastPage) {
        return { loaded: false, appendedCount: 0, firstAppendedBlock: null };
      }
      if (loadedPages[page]) {
        return { loaded: true, appendedCount: 0, firstAppendedBlock: null };
      }
      if (pagePromises[page]) return pagePromises[page];

      pendingPageLoads += 1;
      setLoaderState(true, 'Weitere Marken werden geladen.');

      pagePromises[page] = fetch(getSectionFetchUrl(page), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Brand page request failed');
          return response.text();
        })
        .then(function (html) {
          var result = appendBlocksFromHTML(html);
          loadedPages[page] = true;
          syncNextLink();
          return {
            loaded: true,
            appendedCount: result.appendedCount,
            firstAppendedBlock: result.firstAppendedBlock
          };
        })
        .catch(function () {
          setLoaderState(false, 'Weitere Marken konnten nicht geladen werden. Bitte erneut versuchen.');
          return { loaded: false, appendedCount: 0, firstAppendedBlock: null };
        })
        .finally(function () {
          delete pagePromises[page];
          pendingPageLoads = Math.max(0, pendingPageLoads - 1);
          if (pendingPageLoads > 0) return;

          if (loaderStatus && loaderStatus.textContent === 'Weitere Marken werden geladen.') {
            setLoaderState(false, '');
          } else if (nextLink) {
            nextLink.setAttribute('aria-busy', 'false');
            nextLink.setAttribute('aria-disabled', 'false');
            nextLink.textContent = nextLinkIdleText;
            results.setAttribute('aria-busy', 'false');
            if (loader) loader.classList.remove('is-loading');
          }
        });

      return pagePromises[page];
    }

    async function loadPages(pages) {
      var firstAppendedBlock = null;
      var loadedAny = false;
      var uniquePages = [];

      pages.forEach(function (page) {
        page = Number(page || 0);
        if (page && uniquePages.indexOf(page) === -1) uniquePages.push(page);
      });

      for (var index = 0; index < uniquePages.length; index += 1) {
        var result = await loadPage(uniquePages[index]);
        if (result.loaded) loadedAny = true;
        if (!firstAppendedBlock && result.firstAppendedBlock) firstAppendedBlock = result.firstAppendedBlock;
      }

      return {
        loaded: loadedAny,
        firstAppendedBlock: firstAppendedBlock
      };
    }

    function loadNextSequentialPage(options) {
      options = options || {};
      if (!nextLink || nextLink.getAttribute('aria-disabled') === 'true') {
        return Promise.resolve({ loaded: false, firstAppendedBlock: null });
      }
      var requestId = options.requestId || interactionId;

      return loadPage(nextSequentialPage).then(function (result) {
        if (!isCurrentInteraction(requestId) || activeHandle !== 'all' || (input && normalizeBrandText(input.value))) return result;
        applyFilter();
        if (options.moveFocus && result.firstAppendedBlock) {
          var focusTarget = result.firstAppendedBlock.querySelector('.brand-header__name') || result.firstAppendedBlock;
          focusTarget.focus({ preventScroll: true });
          result.firstAppendedBlock.scrollIntoView({
            block: 'start',
            behavior: prefersReducedMotion ? 'auto' : 'smooth'
          });
        }
        return result;
      });
    }

    function nextInteraction() {
      interactionId += 1;
      return interactionId;
    }

    function isCurrentInteraction(id) {
      return id === interactionId;
    }

    function setActiveChip() {
      chips.forEach(function (chip) {
        var isActive = chip.dataset.brandFilter === activeHandle;
        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function updateStatus(visibleCount, query) {
      if (query) {
        status.textContent = visibleCount + ' von ' + totalBrands + ' Marken gefunden';
      } else if (activeHandle !== 'all') {
        status.textContent = visibleCount === 1 ? '1 Marke angezeigt' : visibleCount + ' Marken angezeigt';
      } else if (blocks.length < totalBrands) {
        status.textContent = blocks.length + ' von ' + totalBrands + ' Marken geladen';
      } else {
        status.textContent = totalBrands + ' Marken angezeigt';
      }
    }

    function applyFilter() {
      collectBlocks();

      var query = input ? normalizeBrandText(input.value) : '';
      var lastVisibleBlock = null;
      var visibleCount = 0;

      blocks.forEach(function (block) {
        block.element.classList.remove('is-last-visible');

        var matchesHandle = activeHandle === 'all' || block.handle === activeHandle;
        var matchesQuery = !query || block.search.indexOf(query) !== -1;
        var isVisible = matchesHandle && matchesQuery;

        block.element.hidden = !isVisible;
        if (isVisible) {
          visibleCount += 1;
          lastVisibleBlock = block.element;
        }
      });

      if (lastVisibleBlock) lastVisibleBlock.classList.add('is-last-visible');
      if (noResults) noResults.hidden = visibleCount !== 0;
      if (loader) loader.hidden = activeHandle !== 'all' || Boolean(query) || !nextLink;
      setActiveChip();
      updateStatus(visibleCount, query);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (event) {
        event.preventDefault();
        window.clearTimeout(debounceTimer);
        var requestId = nextInteraction();
        activeHandle = chip.dataset.brandFilter || 'all';
        if (input) input.value = '';

        if (activeHandle !== 'all' && !getBlockByHandle(activeHandle)) {
          var targetPage = Number(chip.dataset.brandPage || 1);
          status.textContent = 'Marke wird geladen.';
          loadPages([targetPage]).then(function () {
            if (!isCurrentInteraction(requestId) || activeHandle !== chip.dataset.brandFilter) return;
            applyFilter();
            var matchingBlock = getBlockByHandle(activeHandle);
            if (matchingBlock) {
              matchingBlock.element.scrollIntoView({
                block: 'start',
                behavior: prefersReducedMotion ? 'auto' : 'smooth'
              });
              var focusTarget = matchingBlock.element.querySelector('.brand-header__name') || matchingBlock.element;
              if (focusTarget && typeof focusTarget.focus === 'function') {
                focusTarget.focus({ preventScroll: true });
              }
            }
          });
          return;
        }

        applyFilter();
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(function () {
          var requestId = nextInteraction();
          activeHandle = 'all';
          var query = normalizeBrandText(input.value);

          if (query) {
            var matchingPages = getBrandIndex()
              .filter(function (brand) {
                return brand.search.indexOf(query) !== -1;
              })
              .map(function (brand) {
                return brand.page;
              });

            if (matchingPages.length) {
              status.textContent = 'Passende Marken werden geladen.';
            }

            loadPages(matchingPages).then(function () {
              if (isCurrentInteraction(requestId) && query === normalizeBrandText(input.value)) applyFilter();
            });
            return;
          }

          applyFilter();
        }, 120);
      });
    }

    if (reset) {
      reset.addEventListener('click', function () {
        window.clearTimeout(debounceTimer);
        nextInteraction();
        activeHandle = 'all';
        if (input) {
          input.value = '';
          input.focus();
        }
        applyFilter();
      });
    }

    if (nextLink) {
      nextLink.addEventListener('click', function (event) {
        event.preventDefault();
        if (nextLink.getAttribute('aria-disabled') === 'true') return;
        var requestId = nextInteraction();
        loadNextSequentialPage({ moveFocus: true, requestId: requestId });
      });
    }

    if (loader && nextLink && 'IntersectionObserver' in window) {
      autoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var hasQuery = input && normalizeBrandText(input.value);
            if (entry.isIntersecting && activeHandle === 'all' && !hasQuery) {
              loadNextSequentialPage({ moveFocus: false, requestId: interactionId });
            }
          });
        },
        { rootMargin: '400px 0px' }
      );
      autoObserver.observe(loader);
    }

    collectBlocks();
    if (!blocks.length) return;
    syncNextLink();
    applyFilter();
  }

  document.querySelectorAll('[data-brand-finder-root]').forEach(initBrandFinder);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-brand-finder-root]').forEach(initBrandFinder);
  });

  } catch(e) { console.error(e); }
})();
})();
